/* Product details, sharing and a local comparison list. Purchase state stays in fivepoint-pdp.js. */
(() => {
  const compareKey = 'fivepoint.fabric-comparison.v1';
  function connect(root = document) {
    root.querySelectorAll('[data-fp-product-tabs]:not([data-ready])').forEach(details => {
      details.dataset.ready = 'true';
      const tabs = [...details.querySelectorAll('[data-fp-product-tab]')];
      const accordions = [...details.querySelectorAll('[data-fp-product-accordion]')];
      const panels = [...details.querySelectorAll('[data-fp-product-panel]')];
      const mobile = matchMedia('(max-width: 767px)');
      let selected = 0;
      const open = new Set([0]);
      function paint() {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === selected));
          tab.tabIndex = i === selected ? 0 : -1;
          accordions[i].setAttribute('aria-expanded', String(open.has(i)));
          panels[i].hidden = mobile.matches ? !open.has(i) : i !== selected;
          panels[i].setAttribute('role', mobile.matches ? 'region' : 'tabpanel');
          panels[i].setAttribute('aria-labelledby', mobile.matches ? accordions[i].id : tab.id);
        });
      }
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => { selected = i; open.add(i); paint(); });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); tabs[next].click(); tabs[next].focus(); }
        });
        accordions[i].addEventListener('click', () => { open.has(i) ? open.delete(i) : open.add(i); selected = i; paint(); });
      });
      mobile.addEventListener('change', paint);
      paint();
    });
    root.querySelectorAll('[data-fp-pdp-tools]:not([data-ready])').forEach(tools => {
      tools.dataset.ready = 'true';
      tools.querySelector('[data-fp-copy-link]').addEventListener('click', async () => {
        const status = tools.querySelector('[data-fp-share-status]');
        try { await navigator.clipboard.writeText(tools.querySelector('[data-fp-share-url]').value); status.textContent = window.FivePointI18n.t("Link copied."); }
        catch { status.textContent = window.FivePointI18n.t("Could not copy the link. Select and copy the address above."); }
      });
      const dialog = tools.querySelector('[data-fp-compare-dialog]');
      const status = tools.querySelector('[data-fp-compare-status]');
      const table = tools.querySelector('[data-fp-compare-table]');
      const current = { url: tools.dataset.productUrl, title: tools.dataset.title, image: tools.dataset.image, composition: tools.dataset.composition, weight: tools.dataset.weight, width: tools.dataset.width };
      function read() {
        const stored = localStorage.getItem(compareKey);
        const list = stored === null ? [] : JSON.parse(stored);
        if (!Array.isArray(list) || list.length > 4 || list.some(item => !item || !/^\/products\/[a-z0-9-]+$/i.test(item.url) || ['title', 'image', 'composition', 'weight', 'width'].some(key => typeof item[key] !== 'string'))) throw new Error(window.FivePointI18n.t("Invalid comparison list"));
        return list;
      }
      let refresh;
      async function paint(list) {
        refresh?.abort();
        table.replaceChildren();
        table.removeAttribute('aria-busy');
        if (!list.length) { table.textContent = window.FivePointI18n.t("Your comparison list is empty."); return; }
        if (document.querySelector('[data-dss-market-context]')?.dataset.enabled === 'true') {
          const controller = new AbortController(); refresh = controller;
          table.setAttribute('aria-busy', 'true'); table.textContent = window.FivePointI18n.t("Loading current fabric details…");
          try { list = await window.DSSMarketPresentation.resolve(list, controller.signal); }
          catch {
            if (controller.signal.aborted) return;
            table.replaceChildren(); status.textContent = window.FivePointI18n.t("Fabric details could not be refreshed. Close and reopen to retry.");
            table.removeAttribute('aria-busy'); return;
          }
          if (controller.signal.aborted) return;
          table.replaceChildren(); table.removeAttribute('aria-busy');
        }
        list.forEach(item => {
          const card = document.createElement('article');
          const link = document.createElement('a'); link.href = window.FivePointI18n.localUrl(item.url); link.textContent = item.title;
          const imageUrl = new URL(item.image, location.origin);
          if (imageUrl.protocol === 'https:' && (imageUrl.origin === location.origin || imageUrl.hostname === 'cdn.shopify.com')) {
            const image = document.createElement('img'); image.src = imageUrl.href; image.alt = ''; image.width = 180; image.height = 180; card.append(image);
          }
          card.append(link);
          const specs = document.createElement('dl');
          [[window.FivePointI18n.t("Content"), item.composition], [window.FivePointI18n.t("Weight"), item.weight], [window.FivePointI18n.t("Width"), item.width]].forEach(([label, value]) => { const dt = document.createElement('dt'); dt.textContent = label; const dd = document.createElement('dd'); dd.textContent = value || window.FivePointI18n.t("Not specified"); specs.append(dt, dd); });
          const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = window.FivePointI18n.t("Remove"); remove.setAttribute('aria-label', window.FivePointI18n.t("Remove {{p0}} from comparison", [item.title]));
          remove.addEventListener('click', () => {
            try {
              const before = read();
              const remaining = before.filter(saved => saved.url !== item.url);
              localStorage.setItem(compareKey, JSON.stringify(remaining));
              if (remaining.length < before.length) window.FivePointEvents?.emit('fp_compare_change', {action:'remove',item_count:before.length-remaining.length}, {component_id:'product-compare'});
              paint(remaining); status.textContent = window.FivePointI18n.t("Fabric removed.");
            }
            catch { status.textContent = window.FivePointI18n.t("Could not update the saved comparison list."); }
          });
          card.append(specs, remove); table.append(card);
        });
      }
      tools.querySelector('[data-fp-compare-open]').addEventListener('click', () => {
        table.replaceChildren(); status.textContent = '';
        try {
          let list = read();
          const previousCount = list.length;
          const exists = list.some(item => item.url === current.url);
          if (exists) list = list.map(item => item.url === current.url ? current : item);
          else if (list.length < 4) list.push(current);
          else status.textContent = window.FivePointI18n.t("Your list is full. Remove a fabric, then reopen comparison to add this fabric.");
          localStorage.setItem(compareKey, JSON.stringify(list));
          if (list.length > previousCount) window.FivePointEvents?.emit('fp_compare_change', {action:'add',item_count:1}, {component_id:'product-compare'});
          paint(list);
        } catch { status.textContent = window.FivePointI18n.t("Could not load or save comparisons in this browser. Check that site storage is available."); }
        dialog.showModal();
      });
      tools.querySelector('[data-fp-compare-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
    });
  }
  connect();
  document.addEventListener('shopify:section:load', event => connect(event.target));
})();
